module.exports = __webpack_public_path__ + "static/media/UNDER.9c117ed8.png";